export const documentProps = {
  title: 'Eliminate Business Bottlenecks with AI Automation',
  description:
    'TenK Solutions automates client intake, staff knowledge, and executive reporting for DMV businesses. From first contact to paid invoice — automated. Book a free discovery call today.',
};
